import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, Chip, Menu, MenuItem, IconButton } from '@mui/material';
import { ordersAPI } from '../../Api';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { styled } from '@mui/material/styles';

const statusColors = {
  WAIT_PAY: 'warning',
  PAID: 'success',
  DECLINED: 'error',
  // Добавьте другие статусы при необходимости
};

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: 16,
  boxShadow: '0 4px 24px rgba(0,0,0,0.07)',
  marginTop: theme.spacing(3),
}));

function formatOrderId(order_id) {
  if (!order_id) return '';
  if (order_id.length < 12) return order_id;
  return `${order_id.slice(0, 6)}...${order_id.slice(-6)}`;
}

function formatDate(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const pad = (n) => n.toString().padStart(2, '0');
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

import { useNavigate } from 'react-router-dom';

function FunPayOrderList() {
  const [rows, setRows] = useState([]);
  const [anchorEls, setAnchorEls] = useState({});
  const [copiedId, setCopiedId] = useState(null);
  const navigate = useNavigate();
  const getRows = async () => {
    const response = await ordersAPI.getFunPayOrders();
    setRows(response.data.data);
  };
  useEffect(() => {

    getRows();
  }, []);

  const handleMenuOpen = (event, id) => {
    setAnchorEls((prev) => ({ ...prev, [id]: event.currentTarget }));
  };

  const handleMenuClose = (id) => {
    console.log('id', id)
    setAnchorEls((prev) => ({ ...prev, [id]: null }));
  };

  const handleCopyOrderId = (order_id, id) => {
    navigator.clipboard.writeText(order_id);
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 1000);
  };
  const setPaid = async (id) => {
    await ordersAPI.setPaid(id);
    getRows();
  }
  const funPayConfirm = (id) => {
    navigate(`/funpay-chat/${id}`);
  }

  return (
    <Box sx={{ width: '100%' }}>
      <StyledTableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="orders table">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell>Ордер</TableCell>
              <TableCell align="right">Сумма</TableCell>
              <TableCell align="right">Статус</TableCell>
              <TableCell align="right">Клиент</TableCell>
              <TableCell align="right">Дата</TableCell>
              <TableCell align="right">Действие</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 }, transition: 'background 0.2s', ':hover': { background: '#f0f7ff' } }}
              >
                <TableCell component="th" scope="row">
                  <span
                    title={row.order_id}
                    style={{ fontFamily: 'monospace', cursor: 'pointer', color: copiedId === row.id ? '#388e3c' : undefined, userSelect: 'none' }}
                    onClick={() => handleCopyOrderId(row.order_id, row.id)}
                  >
                    {copiedId === row.id ? 'Скопировано!' : formatOrderId(row.order_id)}
                  </span>
                </TableCell>
                <TableCell align="right">{row.total_amount}</TableCell>
                <TableCell align="right">
                  <Chip
                    label={row.status}
                    color={statusColors[row.status] || 'default'}
                    variant="outlined"
                    sx={{ fontWeight: 600, letterSpacing: 1 }}
                  />
                </TableCell>
                <TableCell align="right">{row.client_id.firstName + ' ' + row.client_id.lastName}</TableCell>
                <TableCell align="right">{formatDate(row.created_at)}</TableCell>
                <TableCell align="right">
                  <IconButton
                    aria-label="more"
                    aria-controls={`menu-${row.id}`}
                    aria-haspopup="true"
                    onClick={(e) => handleMenuOpen(e, row.id)}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    id={`menu-${row.id}`}
                    anchorEl={anchorEls[row.id]}
                    open={Boolean(anchorEls[row.id])}
                    onClose={() => handleMenuClose(row._id)}
                  >
                    <MenuItem onClick={() => { funPayConfirm(row._id); handleMenuClose(row._id); }} sx={{ color: 'green' }}>Подтвердить на Фанпей</MenuItem>
                    <MenuItem onClick={() => { setPaid(row._id); handleMenuClose(row._id); }} sx={{ color: 'blue' }}>Оплачено</MenuItem>
                  </Menu>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </Box>
  );
}

export default FunPayOrderList;
